import React from 'react';
import Reaptcha from 'reaptcha';
import { FORM_ERROR } from 'final-form';
import activationApi from '../../network/api/activationApi';

type Props = {
  onValidate: (value: string) => void
};

type State = {
  keyLoaded: boolean,
  captchaKey: string | undefined,
};

export default class Captcha extends React.Component<Props, State> {
  state = {
    keyLoaded: false,
    captchaKey: undefined,
  };

  captchaRef = React.createRef<Reaptcha>();

  componentDidMount(): void {
    this.getCaptchaKey();
  }

  shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>): boolean {
    return this.state.captchaKey !== nextState.captchaKey;
  }

  resetCaptcha = (): void => {
    this.onExpire();
  };

  getCaptchaKey = (): void => {
    activationApi.getRecaptchaKey().then((data) => {
      this.setState({ captchaKey: data.value, keyLoaded: true });
    }, () => ({ [FORM_ERROR]: 'Un problème est survenue avec la génération du captcha. Vous devriez recharger la page ou réessayer plus tard.' }));
  };

  onChange = (captchaResponse: string): void => {
    this.props.onValidate(captchaResponse);
  };

  onExpire = (): void => {
    if (this.captchaRef.current) {
      this.captchaRef.current.reset().then(this.captchaRef.current.execute);
    }
    this.onChange(undefined);
  };

  forceCaptcha = (): Promise<void> => this.captchaRef.current.execute();

  render(): React.ReactElement {
    if (!this.state.keyLoaded) {
      return (
        <></>
      );
    }
    return (
      <Reaptcha
        ref={this.captchaRef}
        sitekey={this.state.captchaKey}
        onVerify={this.onChange}
        onRender={() => this.captchaRef.current.execute()}
        onExpire={this.onExpire}
        size="invisible"
        hl="fr"
      />
    );
  }
}
